import restaurantMealsActions from "../actionTypes/restaurantMealsActions"

const initialState = {
  isLoading: true,
  per: 10,
  page: 1,
  data: {meals: [], total_meals: 0}
}

const restaurantMealsReducer = (state=initialState, action) => {
  switch(action.type) {
    case restaurantMealsActions.getRestaurantMeals:
      return { ...state, ...action.payload, isLoading: true}
    case restaurantMealsActions.getRestaurantMealsSuccess:
      return { ...state, ...action.payload, errors: null, isLoading: false }
    case restaurantMealsActions.getRestaurantMealsFailed:
      return { ...state, ...action.payload, data: {meals: [], total_meals: 0}, isLoading: false }
    default:
      return state
  }
}

export default restaurantMealsReducer;